export default "__VITE_ASSET__62c13ed5__"